import { openMeldRequestContextSchema } from "./schemas/daemon/profile-identity.js";
import { resolvedSpaceMemberProfileSchema } from "./schemas/http/space-members.js";
import * as z$1 from "zod/v4";
//#region src/space-invitation.ts
const id = z$1.string().trim().min(1).max(200);
const ORGANIZATION_INVITATION_LIFETIME_SECONDS = 2880 * 60;
const spaceInvitationRequestSchema = z$1.discriminatedUnion("action", [
	z$1.strictObject({
		action: z$1.literal("create"),
		organizationId: id,
		spaceId: id,
		email: z$1.string().trim().toLowerCase().pipe(z$1.email()),
		audience: z$1.enum(["organization", "guest"]).optional()
	}),
	z$1.strictObject({
		action: z$1.literal("list"),
		organizationId: id,
		spaceId: id,
		audience: z$1.enum(["organization", "guest"]).optional()
	}),
	z$1.strictObject({ action: z$1.literal("pending") }),
	z$1.strictObject({
		action: z$1.literal("preview"),
		invitationId: id
	}),
	z$1.strictObject({
		action: z$1.literal("accept"),
		invitationId: id
	}),
	z$1.strictObject({
		action: z$1.literal("revoke"),
		invitationId: id
	}),
	z$1.strictObject({
		action: z$1.literal("resend"),
		invitationId: id
	})
]);
const spaceInvitationSchema = z$1.strictObject({
	id,
	organizationId: id,
	organizationName: z$1.string(),
	spaceId: id,
	spaceName: z$1.string(),
	inviterName: z$1.string(),
	email: z$1.email(),
	audience: z$1.enum(["organization", "guest"]).optional(),
	status: z$1.enum([
		"pending",
		"accepting",
		"accepted",
		"revoked",
		"expired"
	]),
	expiresAt: z$1.number().int()
});
const spaceInvitationResponseSchema = z$1.discriminatedUnion("ok", [z$1.strictObject({
	ok: z$1.literal(true),
	invitations: z$1.array(spaceInvitationSchema)
}), z$1.strictObject({
	ok: z$1.literal(false),
	code: id,
	message: z$1.string()
})]);
const spaceInvitationRpcInputSchema = z$1.strictObject({
	userId: id,
	email: z$1.email(),
	emailVerified: z$1.boolean(),
	request: z$1.union([
		spaceInvitationRequestSchema,
		z$1.strictObject({
			action: z$1.literal("create_approved"),
			requestId: id
		}),
		z$1.strictObject({
			action: z$1.literal("bind"),
			invitationId: id,
			organizationInvitationId: id,
			organizationInvitationOwned: z$1.boolean()
		}),
		z$1.strictObject({
			action: z$1.literal("claim"),
			invitationId: id
		}),
		z$1.strictObject({
			action: z$1.literal("complete"),
			invitationId: id
		})
	])
});
const spaceInvitationRpcResultSchema = z$1.strictObject({
	result: spaceInvitationResponseSchema,
	organizationInvitationId: id.nullable().optional(),
	organizationMember: z$1.boolean().optional(),
	cancelOrganizationInvitation: z$1.boolean().optional()
});
const spaceInvitationAccessInputSchema = z$1.strictObject({
	spaceId: id,
	context: openMeldRequestContextSchema,
	audience: z$1.enum(["organization", "guest"]).optional(),
	intent: z$1.enum(["invite", "manage"]).optional()
});
const spaceInvitationGrantInputSchema = spaceInvitationAccessInputSchema.extend({
	invitationId: id,
	member: resolvedSpaceMemberProfileSchema
});
const spaceInvitationRevokeInputSchema = spaceInvitationAccessInputSchema.extend({ invitationId: id });
//#endregion
export { ORGANIZATION_INVITATION_LIFETIME_SECONDS, spaceInvitationAccessInputSchema, spaceInvitationGrantInputSchema, spaceInvitationRequestSchema, spaceInvitationResponseSchema, spaceInvitationRevokeInputSchema, spaceInvitationRpcInputSchema, spaceInvitationRpcResultSchema, spaceInvitationSchema };

//# sourceMappingURL=space-invitation.js.map